
/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, June 19, 2014
 * For information or permission request, email info@aetonixsystems.com
 */

"use strict";

var Model = require("../types/Model.js");
var par = require("par");

module.exports = Model({
	name: "managedcareplanchangeviewer",
	init: init,
	listeners: listeners,
	triggers: triggers,

	_viewing: "",
	_changes: null,

	hide: hide,
	recalculate: recalculate,
});

function init() {
	this._viewing = "";
	this._changes = {};
	this.push(null);
}

function listeners() {
	return {
		"managedcareplanchangedfields:updated": handle_fields_updated,
	};
}

function triggers() {
	return {
		view: view,
		hide: hide,
	};
}

function view(data) {
	var key = data.key;
	var keys = data.keys;

	this._viewing = key || keys;
	this.recalculate();
}

function getChanges(changes, result, key) {
	var foundChanges = changes[key];
	if(!foundChanges) return result;

	var newChanges = foundChanges.filter(function(change){
		return result.indexOf(change) === -1;
	});

	if(!newChanges.length) return result;

	return result.concat(newChanges);
}

function hide() {
	this._viewing = "";
	this.push(null);
}

function handle_fields_updated(changes) {
	this._changes = changes;
	this.recalculate();
}

function recalculate() {
	var viewing = this._viewing;
	if(!viewing) return;
	var changes = this._changes;
	if(!changes) return;
	var keyNames = viewing.split(",");
	var allChanges = keyNames.reduce(par(getChanges, changes), []);
	if(allChanges.length === 0){
		this.hide();
	}
	else this.push(allChanges);
}
